const defaultGetValue = 'hello'

export class WebStorageMock {
  get = jest.fn((key: string) => defaultGetValue)
  set = jest.fn((key: string, value: any) => undefined)
  remove = jest.fn((key: string) => undefined)
  clear = jest.fn(() => undefined)
  getWholeDb = jest.fn(() => ({}))
}



// WEBPACK FOOTER //
// ./src/modules/web-storage/__mocks/web-storage.service-mock.ts